import { useOnboardingWizardDismiss } from './useOnboardingWizardDismiss';
import { requestOpenOnboardingWizard } from './onboardingWizardOpenRequest';

/** Clear dismiss and open the Getting started checklist (Help menu entry). */
export const reopenOnboardingWizard = (showAgain: () => void): void => {
  showAgain();
  requestOpenOnboardingWizard();
};

export const useReopenOnboardingWizard = (): (() => void) => {
  const { showAgain } = useOnboardingWizardDismiss();
  return () => reopenOnboardingWizard(showAgain);
};
